import { decodePrincipal, Role } from '@invite/app-core';

/** A token that does not decode, or does not carry the owner role, must never become the session. */
export const isOwnerToken = (token: string): boolean => {
  try {
    return decodePrincipal(token).role === Role.OWNER;
  } catch {
    return false;
  }
};
